import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { throwIfEmpty } from 'rxjs/operators';
import { ProfileService } from '../profile/profile/profile.service';
import { GlobalService } from '../services/global.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/account/auth.service';

@Component({
    selector: 'app-phone-verify',
    templateUrl: './phone-verify.component.html',
    styleUrls: ['./phone-verify.component.scss'],
    standalone: false
})
export class PhoneVerifyComponent implements OnInit {

  @Input() dial_code: string;
  @Input() phone_number: string;
  @Input() enabled: boolean;
  @Input() phoneConfirmed: boolean = false;
  @Input() portrait: boolean = false;
  @Input() userExists: boolean = false;
  @Output() confirmNumber = new EventEmitter<string>();
  @Output() clearEvent = new EventEmitter();
  @Output() failed = new EventEmitter();

  sendCodeValue: string = '';
  verificationCode: string = '';
  sendStatus: number = 0;
  phoneVerificationClosed: boolean = true;
  errorMessage: string = '';
  constructor(public globalService: GlobalService, private profileService: ProfileService, private _router: Router, private authService: AuthService) { }

  ngOnInit(): void {
    if (this.phoneConfirmed == true)
      this.sendStatus = 2;
  }

  async SendCode() {
    if (this.userExists) { 
      var user = await this.profileService.getUserIdByPhoneNumber(this.phone_number);
      if (user == '')
      {
        this.errorMessage = "No account is associated with this phone number.";
        return;
      }
    }

    var result = await this.profileService.sendCodeByPhone(this.dial_code + this.phone_number);
    this.verificationCode = "";
    if (result.message == '')
      this.sendStatus = 1;
  }

  async VerifyCode() {
    var result = await this.profileService.VerifyPhoneNumberByRequestId(
      this.dial_code + this.phone_number,
      this.verificationCode
    );
    if (result.message == '') { // Code Verified
      this.phoneConfirmed = true;
      this.sendStatus = 2;
      this.confirmNumber.emit(this.phone_number);
      if (result['firstName'] != undefined && result['firstName'] != '')
        await this.authService.handleAuthentication(result['email'], result['id'], result['memberId'], result['isLeader'], 
          result['firstName'], result['lastName'], result['phoneNumber'], result['roles'], result['token'],
          result['expiration'], result['language']);      
    }
    else {
      this.sendStatus = 0;  
      this.phone_number = "";
      this.phoneConfirmed = false;
      this.verificationCode = "";
      this.failed.emit(); 
    }
  }

  phoneNumberChange(event)
  {
      this.errorMessage = ''; 
  }

  Clear() {
    this.phoneConfirmed = false;
    this.phone_number = '';
    this.verificationCode = "";
    this.sendStatus = 0;
    this.clearEvent.emit();
  }

  Retry() {
    this.errorMessage = "";
    this.Clear();
  }

  Signup() {
    this._router.navigate(['/signup']);
  }

}
